import { render } from "./MdDateIcon.vue?vue&type=template&id=1166b548"
import script from "./MdDateIcon.vue?vue&type=script&lang=js"
export * from "./MdDateIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__